import { render, staticRenderFns } from "./recollect.vue?vue&type=template&id=91bba2ca&scoped=true"
import script from "./recollect.vue?vue&type=script&lang=js"
export * from "./recollect.vue?vue&type=script&lang=js"
import style0 from "./recollect.vue?vue&type=style&index=0&id=91bba2ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bba2ca",
  null
  
)

export default component.exports